import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"

import { TextField } from "components"
import PocaaCustomerSelect from "./PocaaCustomerSelect"
import classes from "./index.module.scss"

const PoCustomerDetails = props => {
  const {
    formErrors,
    customerInfo,
    setCustomerInfo,
    setCustomerAddress,
    initialCustomerInfoState,
    initialCustomerAddressState
  } = props

  const [t] = useTranslation()

  const handleChange = (value, name) => {
    setCustomerInfo((prev) =>
      ({ ...prev, [name]: value })
    )
  }

  return (
    <Fragment>
      <div className={classes["title"]}>
        {t("جزئیات_مشتری")}
      </div>

      <PocaaCustomerSelect
        formErrors={formErrors}
        customerInfo={customerInfo}
        setCustomerInfo={setCustomerInfo}
        setCustomerAddress={setCustomerAddress}
        initialCustomerInfoState={initialCustomerInfoState}
        initialCustomerAddressState={initialCustomerAddressState}
      />

      <TextField
        type="text"
        label={t("نام_مشتری_را_وارد_کنید")}
        className={classes["input"]}
        value={customerInfo.fullName}
        error={formErrors.fullName}
        onChange={(e) => handleChange(e.target.value, "fullName")}
      />
    </Fragment>
  )
}

export default React.memo(PoCustomerDetails)